let googleApiLoaderPromise = false;

function loadAutoCompleteAPI() {
  let script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + process.env.VUE_APP_GOOGLE_API_KEY + '&language=en&libraries=places&callback=gmapsCallback';
  document.querySelector('head').appendChild(script);
}

export default function googleApiLoader() {
  googleApiLoaderPromise = googleApiLoaderPromise || new Promise(function(resolve, reject) {
    if (window.google) {
      resolve(window.google)
    } else {
      loadAutoCompleteAPI();

      window.gmapsCallback = function() {
        resolve(window.google);
      };
    }
  });

  return googleApiLoaderPromise;
}
